import React from 'react';
import { Typography, Divider, Row, Col, Switch, ColorPicker } from 'antd';

const { Title, Text } = Typography;

// ColorField vive a NIVEL DE MÓDULO a propósito. Si se define DENTRO de
// ColoresTab, cada onChange (que ocurre en cada movimiento del cursor sobre la
// paleta) re-renderiza el padre y React ve una función NUEVA para ColorField →
// lo desmonta y REMONTA → el popover del ColorPicker se cierra en cada cambio,
// impidiendo recorrer la paleta con el click apretado. Hoisteado, la identidad
// es estable y el picker funciona como cualquier selector de color.
const ColorField = ({ label, description, configKey, value, onChange }) => (
  <div style={{ marginBottom: 16 }}>
    <Row align="middle" gutter={12}>
      {/* `flex="auto"` y no un span fijo. Este tab vive DENTRO de una columna
          de 8/24 (Micrositio usa `tabPosition="left"`), y ahí un `md={8}` para
          la etiqueta se resuelve contra un ancho que ya es un tercio del
          viewport: la etiqueta queda en tres renglones y el ColorPicker con
          `showText` no entra. Con `flex` el campo se acomoda al lugar que
          tenga, que es lo único que puede funcionar en los dos anchos. */}
      <Col flex="auto">
        <Text strong style={{ display: 'block' }}>{label}</Text>
        {description && (
          <Text type="secondary" style={{ fontSize: 12 }}>{description}</Text>
        )}
      </Col>
      <Col>
        <ColorPicker
          value={value}
          onChange={(color) => onChange(configKey, color.toHexString())}
          showText
          size="small"
        />
      </Col>
    </Row>
  </div>
);

const ColoresTab = ({ config, onChange }) => {

  return (
    <div className="colores-tab">
      {/* CABECERA */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Cabecera</Title>

        {/* Fondo inicial */}
        <div style={{ marginBottom: 16 }}>
          <Row align="middle" gutter={12}>
            <Col flex="auto">
              <Text strong style={{ display: 'block' }}>Fondo inicial</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>Color de la barra antes de hacer scroll</Text>
            </Col>
            <Col>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Switch
                  size="small"
                  checked={(config.color_header_initial || 'transparent') === 'transparent'}
                  onChange={(checked) =>
                    onChange('color_header_initial', checked ? 'transparent' : (config.color_primary || '#1a5f2a'))
                  }
                />
                <Text style={{ fontSize: 12, color: '#666' }}>
                  {(config.color_header_initial || 'transparent') === 'transparent' ? 'Transparente' : 'Color sólido'}
                </Text>
              </div>
            </Col>
          </Row>
          {(config.color_header_initial || 'transparent') !== 'transparent' && (
            <div style={{ marginTop: 10, paddingLeft: 8 }}>
              <ColorPicker
                value={config.color_header_initial}
                onChange={(color) => onChange('color_header_initial', color.toHexString())}
                showText
                size="small"
              />
            </div>
          )}
        </div>

        <ColorField onChange={onChange}
          label="Fondo al hacer scroll"
          description="Color sólido que toma la barra de navegación al desplazarse"
          configKey="color_header"
          value={config.color_header || '#1a5f2a'}
        />

        <ColorField onChange={onChange}
          label="Color del menú"
          description="Color del texto de los ítems de navegación"
          configKey="color_nav"
          value={config.color_nav || '#ffffff'}
        />
      </div>

      <Divider />

      {/* HERO ZONE */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Hero Zone</Title>

        <ColorField onChange={onChange}
          label="Color del texto"
          description="Color del título principal del hero"
          configKey="color_hero_text"
          value={config.color_hero_text || '#ffffff'}
        />

      </div>

      <Divider />

      {/* COLORES PRINCIPALES */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Colores Principales</Title>

        <ColorField onChange={onChange}
          label="Color Principal"
          description="Color de marca principal"
          configKey="color_primary"
          value={config.color_primary}
        />

        <ColorField onChange={onChange}
          label="Color Secundario"
          description="Color complementario"
          configKey="color_secondary"
          value={config.color_secondary}
        />
      </div>

      <Divider />

      {/* COLORES DE TEXTO */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Colores de Texto</Title>

        <ColorField onChange={onChange}
          label="Títulos"
          description="Encabezados principales (H1, H2)"
          configKey="color_title"
          value={config.color_title}
        />

        <ColorField onChange={onChange}
          label="Subtítulos"
          description="Encabezados secundarios (H3, H4)"
          configKey="color_subtitle"
          value={config.color_subtitle}
        />

        <ColorField onChange={onChange}
          label="Párrafos"
          description="Texto de contenido"
          configKey="color_paragraph"
          value={config.color_paragraph}
        />
      </div>

      <Divider />

      {/* COLORES DE ICONOS */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Iconos</Title>

        <ColorField onChange={onChange}
          label="Iconos (Normal)"
          configKey="color_icon"
          value={config.color_icon}
        />

        <ColorField onChange={onChange}
          label="Iconos (Hover)"
          description="Al pasar el mouse"
          configKey="color_icon_hover"
          value={config.color_icon_hover}
        />
      </div>

      <Divider />

      {/* CTA */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Llamada a la Acción</Title>

        <ColorField onChange={onChange}
          label="Fondo CTA"
          description="Contenedores destacados"
          configKey="color_cta_bg"
          value={config.color_cta_bg}
        />
      </div>

      <Divider />

      {/* BOTONES */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 16 }}>Botones</Title>

        <Text strong style={{ display: 'block', marginBottom: 12, color: '#666' }}>
          Botón Principal
        </Text>
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12}>
            <ColorField onChange={onChange}
              label="Normal"
              configKey="color_btn_primary"
              value={config.color_btn_primary}
            />
          </Col>
          <Col xs={24} sm={12}>
            <ColorField onChange={onChange}
              label="Hover"
              configKey="color_btn_primary_hover"
              value={config.color_btn_primary_hover}
            />
          </Col>
        </Row>

        <Text strong style={{ display: 'block', marginBottom: 12, color: '#666' }}>
          Botón Secundario
        </Text>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <ColorField onChange={onChange}
              label="Normal"
              configKey="color_btn_secondary"
              value={config.color_btn_secondary}
            />
          </Col>
          <Col xs={24} sm={12}>
            <ColorField onChange={onChange}
              label="Hover"
              configKey="color_btn_secondary_hover"
              value={config.color_btn_secondary_hover}
            />
          </Col>
        </Row>
      </div>

      {/* Preview de botones */}
      <div style={{
        backgroundColor: '#f5f5f5',
        padding: 16,
        borderRadius: 8,
        marginTop: 16,
      }}>
        <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
          Vista previa de botones:
        </Text>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            style={{
              backgroundColor: config.color_btn_primary,
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 500,
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = config.color_btn_primary_hover}
            onMouseOut={(e) => e.target.style.backgroundColor = config.color_btn_primary}
          >
            Botón Principal
          </button>
          <button
            style={{
              backgroundColor: config.color_btn_secondary,
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 500,
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = config.color_btn_secondary_hover}
            onMouseOut={(e) => e.target.style.backgroundColor = config.color_btn_secondary}
          >
            Botón Secundario
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColoresTab;
